import React from "react";
import {
  ShieldCheck, Store, SprayCan, PawPrint, Repeat, Home, Building2, Languages,
} from "lucide-react";

// Canonical highlight key → icon. Labels come from i18n so EN/ES both work.
const HIGHLIGHT_ICONS = {
  insured: ShieldCheck,
  locally_owned: Store,
  supplies_included: SprayCan,
  pet_friendly: PawPrint,
  recurring_available: Repeat,
  residential_cleaning: Home,
  commercial_cleaning: Building2,
  english_speaking: Languages,
  spanish_speaking: Languages,
};

// "Why Choose Us" — renders ONLY when the owner explicitly selected at
// least one highlight. We never invent claims. Presentation is a responsive
// feature grid: 1 col mobile → 2 cols small → 3 cols desktop.
export const PublicBusinessHighlights = ({ highlights, t }) => {
  const items = (highlights || []).filter((h) => HIGHLIGHT_ICONS[h]);
  if (items.length === 0) return null;
  return (
    <section
      className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-10 lg:p-14 mb-5 lg:mb-8"
      data-testid="public-highlights-section"
    >
      <span className="block w-10 h-1 rounded-full bg-green-700 mb-3" aria-hidden="true" />
      <h2 className="font-display text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-900 tracking-tight">
        {t("public.highlights.title")}
      </h2>
      <div className="mt-4 lg:mt-8 grid grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-2.5 lg:gap-4">
        {items.map((key) => {
          const Icon = HIGHLIGHT_ICONS[key];
          return (
            <div
              key={key}
              className="flex items-center gap-2 sm:gap-2.5 lg:gap-3.5 px-2.5 py-2 sm:px-3.5 sm:py-3 lg:px-5 lg:py-4 rounded-lg lg:rounded-xl border border-green-100 bg-green-50/60 hover:border-green-300 hover:bg-green-50 transition-colors"
              data-testid={`public-highlight-${key}`}
            >
              <span className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 rounded-md lg:rounded-lg bg-white border border-green-100 flex items-center justify-center shrink-0">
                <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 lg:w-5 lg:h-5 text-green-800" />
              </span>
              <span className="min-w-0 break-words text-xs sm:text-sm lg:text-[15px] font-medium leading-snug text-gray-800">
                {t(`public.highlight.${key}`)}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
};
